(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bodytone-banner-flexible"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-flex-banner')){
  customElements.define('bt-flex-banner',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.index=0;this.userPaused=false;this.hovered=false;this.visible=true;this.editorPaused=false;
      if(this.slides.length<2)return;
      this.classList.add('is-ready');this.controls=this.querySelector('[data-controls]');if(this.controls)this.controls.hidden=false;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      const listen=(target,event,fn,options={})=>target.addEventListener(event,fn,{...options,signal:this.abort.signal});
      listen(this,'click',event=>{
        const control=event.target.closest('button');if(!control)return;
        if(control.hasAttribute('data-prev'))this.go(this.index-1,true);
        if(control.hasAttribute('data-next'))this.go(this.index+1,true);
        if(control.hasAttribute('data-go'))this.go(Number(control.dataset.go),true);
        if(control.hasAttribute('data-pause')){this.userPaused=!this.userPaused;this.updatePause();this.schedule();}
      });
      listen(this,'keydown',event=>{if(!event.target.closest('[data-controls]'))return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1),true);}});
      listen(this,'mouseenter',()=>{this.hovered=true;this.schedule();});listen(this,'mouseleave',()=>{this.hovered=false;this.schedule();});
      listen(this,'focusin',()=>this.schedule());listen(this,'focusout',()=>queueMicrotask(()=>{if(this.isConnected)this.schedule();}));
      listen(document,'visibilitychange',()=>this.schedule());listen(this.motion,'change',()=>{this.updatePause();this.schedule();});
      listen(this,'touchstart',event=>{this.touchX=event.touches[0].clientX;this.touchY=event.touches[0].clientY;},{passive:true});
      listen(this,'touchend',event=>{if(this.dataset.swipe!=='true'||this.touchX==null||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-this.touchX;const dy=event.changedTouches[0].clientY-this.touchY;this.touchX=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1),true);},{passive:true});
      listen(document,'shopify:block:select',event=>{const i=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);if(i>=0){this.editorPaused=true;this.go(i);}});
      listen(document,'shopify:block:deselect',event=>{if(this.slides.some(slide=>slide.dataset.blockId===event.detail.blockId)){this.editorPaused=false;this.schedule();}});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.1});this.observer.observe(this);
      this.go(0);this.updatePause();
    }
    go(next,manual=false){
      this.index=(next+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const on=i===this.index;slide.hidden=false;slide.classList.toggle('is-active',on);slide.inert=!on;slide.setAttribute('aria-hidden',String(!on));});
      this.querySelectorAll('[data-go]').forEach(dot=>{if(Number(dot.dataset.go)===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      const status=this.querySelector('[data-status]');if(status&&manual)status.textContent=`Diapositiva ${this.index+1} de ${this.slides.length}`;
      this.schedule();
    }
    updatePause(){const button=this.querySelector('[data-pause]');if(!button)return;button.hidden=this.motion.matches;button.setAttribute('aria-pressed',String(this.userPaused));button.setAttribute('aria-label',this.userPaused?'Reanudar reproducción automática':'Pausar reproducción automática');button.querySelector('[data-pause-icon]').hidden=this.userPaused;button.querySelector('[data-play-icon]').hidden=!this.userPaused;}
    schedule(){
      clearTimeout(this.timer);
      if(this.dataset.autoplay!=='true'||this.userPaused||this.editorPaused||this.motion?.matches||document.hidden||!this.visible||this.contains(document.activeElement)||(this.hovered&&this.dataset.hover==='true'))return;
      this.timer=setTimeout(()=>this.go(this.index+1),Math.max(3000,Number(this.dataset.delay)||5000));
    }
    disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	function btyHeaderSticky( doc = document ) {
		let hasTopbar = document.querySelector( '.topbar-section ~ .header-section' ),
			header    = doc.querySelector( '.header.transparent-header' );

		function onShopifyLoaded( callback ) {
			if ( ! header ) {
				setTimeout(
					function() {
						onShopifyLoaded( callback )
					}
				);

				return;
			}

			callback();
		}

		onShopifyLoaded(
			function() {
				if ( ! header ) {
					return;
				}

				const detectScroll = function() {
					if ( window.scrollY > 50 ) {
						header.classList.add( 'is-sticky' );
					} else {
						header.classList.remove( 'is-sticky' );
					}
				}

				if ( Shopify.designMode || ! hasTopbar ) {
					detectScroll();
					window.addEventListener( 'scroll', detectScroll );
				} else {
					const observer = new IntersectionObserver(
						([e]) => e.target.classList.toggle( 'is-sticky', e.intersectionRatio < 1 ),
						{
							rootMargin: '-1px 0px 0px 0px',
							threshold: [1]
						}
					);

					observer.observe( header );
				}
			}
		)
	}

	btyHeaderSticky();

	document.addEventListener(
		'shopify:section:select',
		function( e ) {
			let section = e.target;
			btyHeaderSticky( section );
		}
	);

	document.addEventListener(
		'shopify:block:select',
		function( e ) {
			let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
			btyHeaderSticky( section );
		}
	);

  } catch(e) { console.error(e); }
})();
})();
